import { useContext } from 'react'
import { useIntl } from 'react-intl'

import HiddenInput from 'components/Common/Form/Input/HiddenInput'
import type { FlightSearchDatePickerProps } from 'components/Flights/FlightsSearch/SearchWidget/FlightSearchWidgetMobileForm'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { FlightsFareTypes } from 'constants/flight'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import type { TripStop } from 'tripPlanner/api/types'
import TripContextFlightCalendar from 'tripPlanner/components/Calendar/TripContextFlightCalendar'

interface Props extends FlightSearchDatePickerProps {
  tripStops?: ReadonlyArray<TripStop>
  contextStopId?: number
}

function TripContextFlightDatePickerMobile(props: Props) {
  const { id, minDate, maxDate, featuredRanges, required, tripStops, contextStopId, scrollContainerRef } = props
  const intl = useIntl()
  const { flights, fareType } = useContext(FlightSearchWidgetStateContext)
  const flight = flights.find(flight => flight.id === id)
  const selectDateError = intl.formatMessage({
    id: 'GG1ljxkZ4Dp7SirA1NjY',
    defaultMessage: 'Please select a date',
    description: 'Error message when a flight date is not selected in the vertical date picker',
  })

  return <>
    <HiddenInput
      name="startDate"
      value={flight?.checkinDate?.format(ISO_DATE_FORMAT)}
      required={required}
      invalidMessage={selectDateError}
    />
    <HiddenInput
      name="endDate"
      value={flight?.checkoutDate?.format(ISO_DATE_FORMAT)}
      required={fareType.value === FlightsFareTypes.RETURN && required}
      invalidMessage={selectDateError}
    />
    <TripContextFlightCalendar
      flightId={id}
      tripStops={tripStops}
      contextStopId={contextStopId}
      featuredRanges={featuredRanges}
      minDate={minDate}
      maxDate={maxDate}
      scrollContainerRef={scrollContainerRef}
    />
  </>
}

export default TripContextFlightDatePickerMobile
